import styles from "./imagesDropdown.module.css";

const ImagesDropdown = ({
  data = [],
  setValue,
  value,
  className = "",
  itemClassName = "",
}) => {
  return (
    <div className={`${styles.selectItems} ${className}`.trim()}>
      {data.map((option) => (
        <button
          type="button"
          key={option._id}
          onClick={() => setValue(option)}
          className={
            value?._id === option._id || value === option._id
              ? `${styles.tournamentImage} ${styles.active} ${itemClassName}`.trim()
              : `${styles.tournamentImage} ${itemClassName}`.trim()
          }
        >
          <img src={`${option.path}`} alt={option.name} />
        </button>
      ))}
    </div>
  );
};

export default ImagesDropdown;
